<header  *ngIf="userInfos | async as user" id="page-topbar" (window:scroll)="windowScroll()">
  <div class="layout-width">
    <div class="navbar-header">
      <div class="d-flex">
        <div class="navbar-brand-box horizontal-logo">
          <a routerLink="/" class="logo logo-dark">
                        <span class="logo-sm">
                            <img src="assets/images/logo-sm.png" alt="" height="22">
                        </span>
            <span class="logo-lg">
                            <img src="assets/images/logo-dark.png" alt="" height="22">
                        </span>
          </a>

          <a routerLink="/" class="logo logo-light">
                        <span class="logo-sm">
                            <img src="assets/images/logo-sm.png" alt="" height="22">
                        </span>
            <span class="logo-lg">
                            <img src="assets/images/logo-light.png" alt="" height="22">
                        </span>
          </a>
        </div>

        <button type="button" class="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger shadow-none" id="topnav-hamburger-icon" (click)="toggleMobileMenu($event)">
                    <span class="hamburger-icon">
                        <span></span>
                        <span></span>
                        <span></span>
                    </span>
        </button>
      </div>

      <div class="d-flex align-items-center">
        <div ngbDropdown class="dropdown ms-1 topbar-head-dropdown header-item">
          <button ngbDropdownToggle type="button" class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle">
            <i class="link-icon bi bi-translate fs-4"></i>
          </button>

                <div class="ms-1 header-item">
                    <app-delegation-dropdown></app-delegation-dropdown>
                </div>

          <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end">
            <a href="javascript:void(0);" class="dropdown-item notify-item language py-2" (click)="setLanguage('fr')">
              <img src="assets/images/flags/fr.svg" alt="user-image" class="me-2 rounded" height="18">
              <span class="align-middle">français</span>
            </a>
            <a href="javascript:void(0);" class="dropdown-item notify-item language py-2" (click)="setLanguage('ar')">
              <img src="assets/images/flags/ma.svg" alt="user-image" class="me-2 rounded" height="18">
              <span class="align-middle">العربية</span>
            </a>

            <a href="javascript:void(0);" class="dropdown-item notify-item language py-2" *hasAnyAccess="'EDIT_TRANSLATION'; module: 'MDL_GENERAL'" (click)="toggleLanguageEdit()">
              <i class="d-inline-block wd-20 me-2 bi" [ngClass]="(translationEdit() | async) ? 'bi-pencil' : 'bi-pencil-fill'"></i>
              <span class="align-middle" ancTranslate="global.language.enableEdit">Modification libelles</span>
            </a>

          </div>
        </div>

        <div class="ms-1 header-item d-none d-sm-flex">
          <button type="button" class="btn btn-icon btn-topbar btn-ghost-dark rounded-circle" data-toggle="fullscreen" (click)="fullscreen()">
            <i class="bi bi-arrows-fullscreen fs-lg"></i>
          </button>
        </div>

        <app-dropdown-notification
          [currLang]="currLang"
          (notificationsUpdated)="onNotificationsUpdated()"
        ></app-dropdown-notification>

        <div ngbDropdown class="dropdown ms-sm-3 header-item topbar-user">
          <button ngbDropdownToggle type="button" class="btn shadow-none" id="page-header-user-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span class="d-flex align-items-center">
                            <i class="bi bi-person-fill fs-2"></i>
                            <span class="text-start ms-xl-2">
                                <span class="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{{user.libelle}}</span>
                                <span class="d-none d-xl-block ms-1 fs-sm user-name-sub-text">Super</span>
                            </span>
                        </span>
          </button>
          <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end">
            <h6 class="dropdown-header mb-0">Bienvenue, {{ user.libelle }} !</h6>
            <div class="dropdown-item-text pt-0 pb-2">
              <small class="text-muted"><i class="bi bi-shield-check me-1"></i>{{ user.roles?.join(', ') }}</small>
            </div>
            <a class="dropdown-item" [routerLink]="['/admintest/profiles']"><i class="mdi mdi-account-circle text-muted fs-lg align-middle me-1"></i> <span class="align-middle"> Profile</span></a>
            <a class="dropdown-item" [routerLink]="['/backoffice/delegation']" ><i class="bi bi-people-fill text-muted fs-lg align-middle me-2"></i> <span class="align-middle"> Gestion délégation</span></a>

            <a class="dropdown-item" [routerLink]="['/apps/chat']"><i class="mdi mdi-message-text-outline text-muted fs-lg align-middle me-1"></i> <span class="align-middle"> Messages</span></a>
            <a class="dropdown-item" [routerLink]="['/tickets/overview']"><i class="mdi mdi-calendar-check-outline text-muted fs-lg align-middle me-1"></i> <span class="align-middle"> Taskboard</span></a>
            <div class="dropdown-item-text px-3 py-2">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <i class="bi bi-file-earmark-word text-muted fs-lg align-middle me-2"></i>
                  <span class="align-middle pe-2">Rapport </span>
                </div>
                <div class="form-check form-switch mb-0">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="docxFormatSwitchDropdown"
                    [(ngModel)]="isDocxEnabled"
                    (change)="toggleDocxFormat()">
                </div>
              </div>
            </div>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" routerLink="/pages/profile-settings"><span class="badge bg-success-subtle text-success mt-1 float-end">New</span><i class="mdi mdi-cog-outline text-muted fs-lg align-middle me-1"></i> <span class="align-middle"> Settings</span></a>
            <a *hasAnyRole="'ROLE_ADMIN'" class="dropdown-item" (click)="toggleAccessEdit()">
              <i class="bi me-1 text-muted fs-lg icon-md" [ngClass]="enableEdit() ? 'bi-unlock-fill' : 'bi-lock-fill'"></i>
              <span class="align-middle" ancTranslate="global.edit.access">Edit Accesses</span>
            </a>
            <a class="dropdown-item" href="javascript: void(0);" (click)="logout($event)"><i class="mdi mdi-logout text-muted fs-lg align-middle me-1"></i> <span class="align-middle" data-key="t-logout"> Logout</span></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
